import { createSelector } from "reselect";
import { TeamTemplateSize } from "./teamTemplateSizesActions";
import { TeamTemplateSizesState } from "./teamTemplateSizesReducers";

interface StateWithTeamTemplateSizes {
  entities: {
    teamTemplateSizes: TeamTemplateSizesState;
  };
}

const sliceSelector = (state: StateWithTeamTemplateSizes) =>
  state.entities.teamTemplateSizes;

const entriesSelector = (state: StateWithTeamTemplateSizes) =>
  sliceSelector(state).entries;

const compareByCreatedAtDesc = (a: TeamTemplateSize, b: TeamTemplateSize) => {
  const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
  const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
  return bTime - aTime;
};

export const teamTemplateSizesSelector = createSelector(
  entriesSelector,
  (entries): TeamTemplateSize[] =>
    Object.values(entries).sort(compareByCreatedAtDesc)
);

export const activeTeamTemplateSizesSelector = createSelector(
  teamTemplateSizesSelector,
  (sizes): TeamTemplateSize[] => sizes.filter(size => size.active === true)
);

export const teamTemplateSizeByIdSelector = (
  state: StateWithTeamTemplateSizes,
  id: string
): TeamTemplateSize | undefined => sliceSelector(state).entries[id];

export const isFetchingTeamTemplateSizesSelector = (
  state: StateWithTeamTemplateSizes
): boolean => sliceSelector(state).isFetching;

export const isProcessingTeamTemplateSizesSelector = (
  state: StateWithTeamTemplateSizes
): boolean => sliceSelector(state).isProcessing;

export const teamTemplateSizesLastFetchedSelector = (
  state: StateWithTeamTemplateSizes
): number | null => sliceSelector(state).lastFetched;

export const teamTemplateSizesCachedTeamIdSelector = (
  state: StateWithTeamTemplateSizes
): string | null => sliceSelector(state).teamId;

export const hasTeamTemplateSizesSelector = (
  state: StateWithTeamTemplateSizes
): boolean => Object.keys(sliceSelector(state).entries).length > 0;

export const teamTemplateSizesErrorsSelector = (
  state: StateWithTeamTemplateSizes
): Record<string, string> => sliceSelector(state).errors;
